"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../theme");
const compliance_1 = require("../../../util/compliance/compliance");
const amountUtils_1 = require("../../../util/amountUtils");
const ComplianceKPIContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 ${theme_1.theme.spacing(3)};
  margin-bottom: ${theme_1.theme.spacing(3)};
`;
const ComplianceNumberAndUnit = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;
const ComplianceNumber = styled_components_1.default.div `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(7)};
  text-align: center;

  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    ${theme_1.theme.fontSize(5)};
  }

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    ${theme_1.theme.fontSize(4)};
    margin-bottom: ${theme_1.theme.spacing(2)};
  }

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    ${theme_1.theme.fontSize(3)};
  }
`;
const Unit = styled_components_1.default.div `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(0)};
  align-self: flex-end;
  margin-top: -16px;
  text-align: right;
  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    ${theme_1.theme.fontSize(-1)};
  }
`;
const Title = styled_components_1.default.div `
  ${theme_1.theme.fontBold};
  margin-top: ${theme_1.theme.spacing(2)};
  text-align: center;
  ${theme_1.theme.fontSize(1)};
  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    ${theme_1.theme.fontSize(0)};
  }
  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    ${theme_1.theme.fontSize(-1)};
  }
`;
const ComplianceText = styled_components_1.default.div `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(0)};
  margin-top: ${theme_1.theme.spacing(0)};
  text-align: center;
`;
const ComplianceIcon = styled_components_1.default.img `
  width: 24px;
  height: 24px;
  margin-right: ${theme_1.theme.spacing(1)};
`;
exports.default = ({ value, unit, title, compliance }) => {
    const complianceOption = compliance
        ? compliance_1.complianceOptions[compliance]
        : undefined;
    return ((0, jsx_runtime_1.jsxs)(ComplianceKPIContainer, { children: [(0, jsx_runtime_1.jsxs)(ComplianceNumberAndUnit, { children: [(0, jsx_runtime_1.jsx)(ComplianceNumber, { style: { color: complianceOption?.color ?? theme_1.theme.colors.blackText }, children: (0, amountUtils_1.formatNumber)(value, 2) ?? "N/A" }), (0, jsx_runtime_1.jsx)(Unit, { children: unit })] }), (0, jsx_runtime_1.jsx)(Title, { children: title }), complianceOption && ((0, jsx_runtime_1.jsxs)(ComplianceText, { style: { color: complianceOption.color }, children: [(0, jsx_runtime_1.jsx)(ComplianceIcon, { src: complianceOption.icon }), complianceOption.text] }))] }));
};
